import Api from '@/api/Api';
import errorHandler from '@/utils/plugins/ErrorHandler';

const CATALOG_MODULES = '/api/module_permissions/catalog';
const CATALOG_ACTIONS = '/api/security/actions';
const RESOURCE_NAME = '/api/employees';
const MY_PERMISSIONS = '/api/me/permissions';

export default {
    getCatalogModules() {
        return Api().get(CATALOG_MODULES)
            .catch((err) => errorHandler(err, null));
    },
    getCatalogActions() {
        return Api().get(CATALOG_ACTIONS)
            .catch((err) => errorHandler(err, null));
    },
    getPermissions(employeeId) {
        return Api().get(RESOURCE_NAME + `/${employeeId}/permissions`)
            .catch((err) => errorHandler(err, null));
    },
    updatePermissions(employeeId, rows) {
        return Api().put(RESOURCE_NAME + `/${employeeId}/permissions`, rows)
            .catch((err) => errorHandler(err, null));
    },
    getMyPermissions() {
        return Api().get(MY_PERMISSIONS)
            .catch((err) => errorHandler(err, null));
    },
}
